var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSonarQube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#549dd0",
    d: "M102.195 112.023h-5.57c0-44.84-37-81.32-82.477-81.32v-5.57c48.551 0 88.047 38.976 88.047 86.89Zm3.852-29.902C99.359 54 76.567 30.5 48 22.301l1.281-4.461C79.434 26.5 103.5 51.309 110.56 81.047Zm4.281-26.402c-6.887-15.02-18.625-28.117-33.043-36.88l1.93-3.175c15.047 9.145 27.297 22.82 34.5 38.5Zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonarQube);
export default __webpack_public_path__ + "static/media/SonarQube.f201b9e763ee02126c6377e1ef906698.svg";
export { ForwardRef as ReactComponent };